import { getRowClass, getCellClass as cellClass } from 'helpers/cell';

export const getCompanyColumns = (columnsToHide) =>
  [
    {
      Header: 'Company',
      accessor: 'name',
      width: '200px',
      rowGroup: true,
      hide: true,
      pinned: 'left',
      suppressMovable: true,
    },
    {
      Header: 'Contact name',
      accessor: 'contactName',
      disableSortBy: true,
      width: 400,
      cellRenderer: 'contactNameRenderer',
      orderIndex: 2,
      getRowClass,
      cellClass,
    },
    {
      Header: 'Contact job title',
      accessor: 'jobTitle',
      width: '240px',
      disableSortBy: true,
      disablePadding: true,
      cellRenderer: 'companyRowRenderer',
      orderIndex: 3,
      getRowClass,
      cellClass,
    },
    {
      Header: 'Intros offered by',
      accessor: 'intros',
      width: '240px',
      disableSortBy: true,
      disablePadding: true,
      cellRenderer: 'introsRenderer',
      orderIndex: 7,
      getRowClass,
      cellClass,
    },
    {
      Header: 'Contact seniority',
      accessor: 'seniority',
      width: '200px',
      disableSortBy: true,
      disablePadding: true,
      cellRenderer: 'companyRowRenderer',
      orderIndex: 4,
      getRowClass,
      cellClass,
    },
    {
      Header: 'Contact years in company',
      headerTooltip: 'Contact years in company',
      accessor: 'yearsInCompany',
      width: '120px',
      disableSortBy: true,
      disablePadding: true,
      cellRenderer: 'companyRowRenderer',
      orderIndex: 5,
      getRowClass,
      cellClass,
    },
    {
      Header: 'Contact of',
      accessor: 'contactOf',
      width: '240px',
      disableSortBy: true,
      disablePadding: true,
      cellRenderer: 'contactOfRenderer',
      orderIndex: 6,
      getRowClass,
      cellClass,
    },
  ].filter((column) => !columnsToHide.has(column.accessor));
